import { queryI18nLanguageSupport } from "@/api/system-words";

export const CHINESE_CODE = "zh-CN";
export const ENGLISH_CODE = "en-US";

export type LanguageState = {
  CURRENT_LANGUAGE: string;
  LANGUAGE_LIST: Record<string, any>; // 语言列表
  LOCAL_LANGUAGE_LIST: Record<string, any>; // 本地语言列表
};

const language = {
  namespaced: true,
  state: {
    LANGUAGE_LIST: {},
    LOCAL_LANGUAGE_LIST: {},
    CURRENT_LANGUAGE: localStorage.getItem("language"),
  },
  getters: {
    languageDictId: (_: any, __: any, ___: any, rootGetters: any) => {
      return (rootGetters["system/dictionaryList"].find((f: any) => f.code === "language") as any)
        ?.id;
    },
    languageList: (state: LanguageState) => {
      return Object.keys(state.LANGUAGE_LIST).map((key: any) => {
        return {
          label: state.LANGUAGE_LIST[key],
          value: key,
        };
      });
    },
    localLanguageList: (state: LanguageState) => {
      return Object.keys(state.LOCAL_LANGUAGE_LIST).map((key: any) => {
        return {
          label: state.LOCAL_LANGUAGE_LIST[key],
          value: key,
        };
      });
    },
  },
  mutations: {
    setCurrentLanguage(state: LanguageState, language: string) {
      state.CURRENT_LANGUAGE = language;
      localStorage.setItem("language", language);
    },
    setLanguageList: (state: LanguageState, data: any) => (state.LANGUAGE_LIST = data),
    setLocalLanguageList: (state: LanguageState, data: any) => (state.LOCAL_LANGUAGE_LIST = data),
  },
  actions: {
    async getLanguageList({ commit }: any) {
      const res = await queryI18nLanguageSupport({ i18n: false });
      commit("setLanguageList", res.data.data);
      return res.data.data;
    },
    async getLocalLanguageList({ commit }: any) {
      const res = await queryI18nLanguageSupport({ i18n: true });
      commit("setLocalLanguageList", res.data.data);
    },
  },
};

export default language;
